export const isValidYearRange = (yearStr: string) => {
  return 1000 <= Number(yearStr) && Number(yearStr) <= 9999
}
